export default {
	en: {},
	fr: {}
}


// WEBPACK FOOTER //
// ./src/lang/messages.js